// https://docs.metamask.io/guide/ethereum-provider.html#using-the-provider

import React, { useState } from "react";
import { ethers } from "ethers";
import classes from "./ConnectWallet.module.css";
import axios from "axios";
import Card from "./Card";

function ConnectWallet(props) {
  const [errorMessage, setErrorMessage] = useState(null);
  const [defaultAccount, setDefaultAccount] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [connButtonText, setConnButtonText] = useState("Connect Wallet");
  const [validNetwork, setValidNetwork] = useState(true);
  const [totalSupply, setTotalSupply] = useState(50);

  const onTrigger = (event) => {

    console.log("Triggering "+ event)
    try{
        props.callback(event);
    }catch(error){
      console.log(error)
    }
    
    console.log("Triggered")
}

  function connectWallet() {
    if (window.ethereum && window.ethereum.isMetaMask) {
      console.log("MetaMask Here!");

      window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((result) => {
          console.log("NetVer " + window.ethereum.networkVersion);
          setValidNetwork(window.ethereum.networkVersion === "1");
          setDefaultAccount(result[0]);
          accountChangedHandler(result[0]);
          setConnButtonText("Wallet Connected");
          getAccountBalance(result[0]);
          onTrigger(result[0])
        })
        .catch((error) => {
          setErrorMessage(error.message);
        });
    } else {
      console.log("Need to install MetaMask");
      setErrorMessage("Please install MetaMask browser extension to interact");
      alert("Please install metamask extention");
    }
  }

  function checkForOg(address) {
    const data = {};
    data.data = { walletAddress: address };
    console.log("Data " + JSON.stringify(data));
    axios({
      method: "post",
      url: "https://us-central1-cute-mouse.cloudfunctions.net/firebaseMerkle",
      data,
    })
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function accountChangedHandler(newAccount) {
    setValidNetwork(window.ethereum.networkVersion === 1);
    console.log("New Account " + newAccount);
    if (newAccount.toString().length === 0) {
      setDefaultAccount(null);
      setUserBalance(null);
      setConnButtonText("Connect Wallet");
    } else {
      setConnButtonText("Wallet Connected");
      setDefaultAccount(newAccount.toString());
      getAccountBalance(newAccount.toString());
    }
  }

  function getAccountBalance(account) {
    window.ethereum
      .request({ method: "eth_getBalance", params: [account, "latest"] })
      .then((balance) => {
        setUserBalance(ethers.utils.formatEther(balance));
      })
      .catch((error) => {
        console.log("error " + error.message);
        setErrorMessage(error.message);
      });
  }

  function chainChangedHandler() {
    window.location.reload();
  }

  if (window.ethereum && window.ethereum.isMetaMask) {
    window.ethereum.on("accountsChanged", accountChangedHandler);

    window.ethereum.on("chainChanged", chainChangedHandler);
  }

  return (
    <div className={classes.ConnectWallet}>
      {defaultAccount === null && (
        <button className={classes.actions} onClick={connectWallet}>
          {connButtonText}
        </button>
      )}
     {defaultAccount != null && ( <Card>
      {validNetwork && (<h4 className={classes.text}>
            Please connect to Mainnet<br/>
          </h4>)}
        <br/>
        <h4 className={classes.text} >
            Address: {defaultAccount.substring(0, 8)+"..."}
          </h4>
        <br/>
        {userBalance != null && (
          <h4 className={classes.text}>
            Avax Balance: {Number(userBalance).toFixed(6)}
          </h4>
        )}  
      </Card>)} 
    </div>
  );
}

export default ConnectWallet;
